import useSWR from 'swr';

import httpApi from 'hooks/api/httpApi';

import type RefundReasonDto from '../models/RefundReasonDto';

const sortRefundReasons = (a: RefundReasonDto, b: RefundReasonDto) => {
    if (a.label === 'Egyéb') return 1;
    return -1;
};

const getRefundReasons = async (): Promise<RefundReasonDto[]> => {
    const response = await httpApi.get<RefundReasonDto[]>(
        'api/v1/refund-reasons'
    );

    return response.getData().sort(sortRefundReasons);
};

type UseRefundReasonsSWR = () => {
    refundReasons?: RefundReasonDto[];
    loading: boolean;
};

const useRefundReasonsSWR: UseRefundReasonsSWR = () => {
    const { data, isLoading } = useSWR('<refund-reasons>', getRefundReasons, {
        // dedupingInterval: 600000, // 10min
        errorRetryCount: 3,
        // revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });

    return {
        refundReasons: data,
        loading: isLoading,
    };
};

export default useRefundReasonsSWR;
